/* -------------------------------------------------------------------------- */
/*                                    页面权限                                 */
/* -------------------------------------------------------------------------- */

// 全部会员列表
export const ALL_MEMBER_LIST_PAGE_UUID = 'eb48d811-1416-4711-8c92-c9ca7f4e4dd6'
